export default {
      id: "ar_commercants-usage",
      viewBox: "0 0 230 150",
      url: "../dist/images/" + "sprite.svg#ar_commercants-usage",
      toString: function () {
        return this.url;
      }
    }